'use client'

import { clsx } from 'clsx'
import { type FC, useState } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button } from 'base-ui'

import { type AlgoliaRecord } from '../../../algolia'
import { useDeviceDetectorContext } from '../../../device-detector'
import { StoryblokProductBatteryItem } from '../StoryblokProductBatteryItem'

type StoryblokProductBatteryGridProps = {
  itemsPerRow?: string
  products: AlgoliaRecord[]
}

const PRODUCTS_PER_PAGE_DEFAULT = 8
const PRODUCTS_PER_PAGE_12 = 12
const ITEMS_PER_ROW_6 = 6

export const StoryblokProductBatteryGrid: FC<
  StoryblokProductBatteryGridProps
> = ({ itemsPerRow, products }) => {
  const parsedItemsPerRow =
    typeof itemsPerRow === 'string' ? Number(itemsPerRow) : undefined
  const { isMobile } = useDeviceDetectorContext()
  const [productVisibleCount, setProductVisibleCount] = useState(
    parsedItemsPerRow === ITEMS_PER_ROW_6 && !isMobile
      ? PRODUCTS_PER_PAGE_12
      : PRODUCTS_PER_PAGE_DEFAULT,
  )

  return (
    <div className="flex flex-col items-center gap-4 tablet:gap-6">
      <ul
        className={clsx(
          'grid w-full grid-cols-2 gap-4 tablet:grid-cols-4 tablet:gap-y-6',
          parsedItemsPerRow === ITEMS_PER_ROW_6 && 'desktop:grid-cols-6',
        )}
      >
        {products.slice(0, productVisibleCount).map((product) => (
          <li key={product.objectID}>
            <StoryblokProductBatteryItem product={product} />
          </li>
        ))}
      </ul>
      {productVisibleCount < products.length && (
        <Button
          onClick={() => {
            setProductVisibleCount((count) => count + PRODUCTS_PER_PAGE_DEFAULT)
          }}
          size="large"
          variant="outlined"
        >
          <FormattedMessage id="general.label.loadMoreProducts" />
        </Button>
      )}
    </div>
  )
}
